<script setup lang="ts">
import type { NotificationsItemState } from '@/features/Notifications/model/types/notifications';

withDefaults(defineProps<NotificationsItemState>(), {
  title: '',
  subtitle: '',
  time: '',
  iconName: '',
  profilePhotoUrl: '',
  link: '',
});

const isMobile: boolean = useIsMobile();

const nuxtLink = resolveComponent('NuxtLink');
</script>

<template>
  <component
    :is="link ? nuxtLink : 'div'"
    v-bind="link ? { to: link } : {}"
    :class="['notifications-item', { _mobile: isMobile }]"
    data-testid="notification-item"
  >
    <div class="notifications-item__main">
      <div class="notifications-item__avatar">
        <AppIcon
          v-if="iconName"
          class="notifications-item__avatar-icon"
          :name="iconName"
        />
        <NuxtImg
          v-if="profilePhotoUrl"
          class="notifications-item__avatar-image"
          :src="profilePhotoUrl"
          alt="Фотография профиля"
          width="60"
          height="60"
          loading="lazy"
        />
      </div>
      <div class="notifications-item__content">
        <div class="notifications-item__info-wrapper">
          <div class="notifications-item__info">
            <span class="notifications-item__title">
              {{ title }}
            </span>
            <span v-if="time" class="notifications-item__time">
              {{ time }}
            </span>
          </div>
          <p v-if="subtitle" class="notifications-item__subtitle">
            {{ subtitle }}
          </p>
        </div>
      </div>
    </div>
  </component>
</template>

<style lang="less">
.notifications-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: @size-x4;
  border-radius: @main-size;
  background-color: white;
  border: 1px solid @color-alto;
  text-decoration: none;

  &__main {
    display: flex;
    align-items: center;
    width: 100%;
  }

  &__avatar {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 60px;
    height: 60px;
    margin-right: @size-x4;
    border-radius: @main-size;
    border: 1px solid @color-alto;
    overflow: hidden;
  }

  &__avatar-icon {
    width: @size-x10;
    height: @size-x10;
  }

  &__avatar-image {
    width: 60px;
    height: 60px;
    object-fit: cover;
    border-radius: @main-size;
  }

  &__content {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  &__info-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__info {
    display: flex;
    flex-direction: column;
    gap: @main-size;
  }

  &__title {
    font-size: @size-x4;
    font-weight: 700;
    line-height: 130%;
    color: @color-elephant;
  }

  &__subtitle {
    font-size: 14px;
    line-height: 130%;
    font-weight: 600;
    color: @color-silver-chalice;
    margin: 0;
  }

  &__time {
    font-size: @size-x3;
    line-height: 130%;
    font-weight: 500;
    color: @color-silver-chalice;
    flex-shrink: 0;
  }

  &._mobile &__info-wrapper {
    .flex-column(@main-size);

    align-items: flex-start;
  }

  &._mobile &__title {
    .overflow-ellipsis-lines(2);
  }
}
</style>
